<template>
  <div>
    <div id="modalEditarProductos" class="modal">
      <div class="modal-contenido rounded-xl p-1">
        <div
          class="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 justify-items-end"
        >
          <button
            @click="clean()"
            type="button"
            class="col-start-6 end text-xl mx-2 p-1"
          >
            <a class="font-bold" href="#">X</a>
          </button>
        </div>
        <div class="w-full">
          <h4
            class="bg-gray-100 mx-9 mb-1 text-2xl shadow-xl text-black text-center mt-1 rounded"
          >
            Productos
            <hr color="black" size="4" />
          </h4>
        </div>
        <!--<div
          class="border rounded-xl w-80 border-solid border-t-4 border-l-4 border-r-4 border- shadow-2xl"
        >-->
        <div class="uppercase">
          <div class="justify-center mt-2">
            <div
              class="px-10 grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5"
            >
              <div class="col-span-1 mx-7">
                <strong>referencia:</strong>
                <p class="mx-2" v-if="!banderamodal">
                  <strong v-if="!valor"> {{ sreferencia }} </strong>
                </p>

                <select
                  v-if="valor"
                  v-model="referenciaproducto"
                  @click="mostrar()"
                  class="shadow mt-2 rounded h-8 border-b-2 border-black w-44 flex"
                  id="grid-state"
                >
                  <option
                    v-bind:value="referenciaa.idreferencia"
                    :key="referenciaa.idreferencia"
                    v-for="referenciaa of referencias"
                  >
                    <button>
                      {{referenciaa.codigoreferencia}}
                      {{ referenciaa.nombrereferencia }}
                    </button>
                  </option>
                </select>
              </div>

              <div class="col-span-1 mx-5">
                <strong class="mx-2">Codigo:</strong>
                <p class="mx-2" v-if="!banderamodal">
                  <strong v-if="!valor"> {{ scodigoproducto }} </strong>
                </p>

                <input
                  v-model="codigoproducto"
                  v-on:keyup="mostrar()"
                  v-if="valor"
                  class="appearance-none w-full mx-2 w-80 border-b-2 border-black shadow-xl block col-span-3 bg-gray-lighter text-grey-darker rounded py-1"
                
                  type="text"
                  placeholder="Codi... "
                />
              </div>
              <div class="col-span-1 mx-5">
                <strong class="mx-2" >Nombre:</strong>
                <p class="mx-2 2" v-if="!banderamodal">
                  <strong v-if="!valor"> {{ snombreproducto }} </strong>
                </p>

                <input
                  v-model="nombreproducto"
                  v-on:keyup="mostrar()"
                  v-if="valor"
                  class="appearance-none w-full mx-2 w-80 border-b-2 border-black shadow-xl block col-span-3 bg-gray-lighter text-grey-darker rounded py-1"
                
                  type="text"
                  placeholder="Nom... "
                />
              </div>
              <div class="col-span-1  mx-5">
                <strong class="mx-2" >Valor venta:</strong>
                <p class="mx-2 2" v-if="!banderamodal">
                  <strong v-if="!valor"> {{ svalorventa }} </strong>
                </p>

                <input
                  v-model.number="valorventa"
                  v-on:keyup="mostrar()"
                  v-if="valor"
                  class="appearance-none w-full mx-2 w-80 border-b-2 border-black shadow-xl block col-span-3 bg-gray-lighter text-grey-darker rounded py-1"
                  id=""
                  type="number"
                  placeholder="valor de venta "
                />
              </div>
              <div class="col-span-1 mx-5 ">
                <strong>Disponible:</strong>
                <p
                  class="divide divide-y mx-2 divide-black"
                  v-if="!banderamodal"
                >
                  <strong v-if="!valor"> {{ sdisponibleproducto }} </strong>
                </p>
                <input
                  v-model.number="disponibleproducto"
                  v-on:keyup="mostrar()"
                  v-if="valor"
                  class="appearance-none w-full mx-2 w-80 border-b-2 border-black shadow-xl block col-span-3 bg-gray-lighter text-grey-darker rounded py-1"
            
                  type="number"
                  placeholder="disponible"
                />
              </div>
              <div class="col-span-1 mx-5 mt-3">
                <strong class="mx-2">Reserva:</strong>
                <p
                  class="divide divide-y mx-2 divide-black"
                  v-if="!banderamodal"
                >
                  <strong v-if="!valor"> {{ sreservaproducto }} </strong>
                </p>

                <input
                  v-model.number="reservaproducto"
                  v-on:keyup="mostrar()"
                  v-if="valor"
                  class="appearance-none w-full mx-2 w-80 border-b-2 border-black shadow-xl block col-span-3 bg-gray-lighter text-grey-darker rounded py-1"
   
                  type="number"
                  placeholder="reser..."
                />
              </div>
              <div class="col-span-1 mx-5 mt-3">
                <strong class="mx-2">Costo:</strong>
                <p
                  class="divide divide-y mx-2 divide-black"
                  v-if="!banderamodal"
                >
                  <strong v-if="!valor"> {{ scostoproducto }} </strong>
                </p>
                <input
                  v-model.number="costoproducto"
                  v-on:keyup="mostrar()"
                  v-if="valor"
                  class="appearance-none w-full mx-2 w-80 border-b-2 border-black shadow-xl block col-span-3 bg-gray-lighter text-grey-darker rounded py-1"
            
                  type="number"
                  placeholder="costo..."
                />
              </div>
              <div class="col-span-1 mx-5 mt-3">
                <strong class="mx-2">iva:</strong>
                <p
                  class="divide divide-y mx-2 divide-black"
                  v-if="!banderamodal"
                >
                  <strong v-if="!valor"> {{ sivaproducto }} </strong>
                </p>
                <input
                  v-model.number="ivaproducto"
                  v-on:keyup="mostrar()"
                  v-if="valor"
                  class="appearance-none w-full mx-2 w-80 border-b-2 border-black shadow-xl block col-span-3 bg-gray-lighter text-grey-darker rounded py-1"
      
                  type="number"
                  placeholder="iva..."
                />
              </div>
              <div class="col-span-1 mx-5 mt-3">
                <strong class="mx-2">Foto:</strong>
                <p
                  class="divide divide-y mx-2 divide-black"
                  v-if="!banderamodal"
                >
                  <strong v-if="!valor"> {{ sfoto }} </strong>
                </p>
                <input
                  v-model="foto"
                  v-on:keyup="mostrar()"
                  v-if="valor"
                  class="appearance-none w-full mx-2 w-80 border-b-2 border-black shadow-xl block col-span-3 bg-gray-lighter text-grey-darker rounded py-1"

                  type="text"
                  placeholder="foto..."
                />
              </div>

              <div class="col-span-1 mx-7 mt-3">
                <strong>Linea:</strong>
                <p
                  class="divide divide-y mx-2 divide-black"
                  v-if="!banderamodal"
                >
                  <strong v-if="!valor"> {{ sidlineaproducto }} </strong>
                </p>
                <select
                  v-if="valor"
                  @click="mostrar(), dos()"
                  v-model.number="linea"
                  class="shadow mt-2 rounded h-8 border-b-2 border-black w-44 flex"
                >
                  <option disabled value="">Seleccione una Linea</option>
                  <option
                    v-bind:value="lineaa.idlinea"
                    :key="lineaa.idlinea"
                    v-for="lineaa of lineas"
                  >
                    {{ lineaa.nombrelinea }}
                  </option>
                </select>
              </div>
              <div class="col-span-1 mx-7 mt-3">
                <strong>Talla:</strong>
                <p
                  class="divide divide-y mx-2 divide-black"
                  v-if="!banderamodal"
                >
                  <strong v-if="!valor"> {{ sidtallaproducto }} </strong>
                </p>
                <select
                  v-if="valor"
                  @click="mostrar(), dos()"
                  v-model.number="talla"
                  class="shadow mt-2 rounded h-8 border-b-2 border-black w-44 flex"
                >
                  <option disabled value="">Seleccione una talla</option>
                  <option
                    v-bind:value="talla.idtalla"
                    :key="talla.idtalla"
                    v-for="talla of tallas"
                  >
                    {{ talla.nombretalla }}
                  </option>
                </select>
              </div>
              <div class="col-span-1 mx-7 mt-3">
                <strong>Color: </strong>
                <p
                  class="divide divide-y mx-2 divide-black"
                  v-if="!banderamodal"
                >
                  <strong v-if="!valor"> {{ sidcolorproducto }} </strong>
                </p>
                <select
                  v-if="valor"
                  @click="mostrar(), dos()"
                  v-model.number="color"
                  class="shadow mt-2 rounded h-8 border-b-2 border-black w-44 flex"
                  id="grid-state"
                >
                  <option
                    v-bind:value="color.idcolor"
                    :key="color.idcolor"
                    v-for="color of colores"
                  >
                    <button>
                      {{ color.nombrecolor }}
                    </button>
                  </option>
                </select>
              </div>
              <div v-if="valor" class="col-span-1 mx-7 mt-3">
                <strong>Categoria:</strong>
                <p
                  class="divide divide-y mx-2 divide-black"
                  v-if="!banderamodal"
                >
                  <strong v-if="!valor"> {{ sidcategoriaproducto }} </strong>
                </p>

                <select
                  @click="mostrar(), dos()"
                  v-model.number="categoria"
                  class="shadow mt-2 rounded h-8 border-b-2 border-black w-44 flex"
                  id="grid-state"
                >
                  <option
                    v-bind:value="categoria.idcategoria"
                    :key="categoria.idcategoria"
                    v-for="categoria of categorias"
                  >
                    <button>
                      {{ categoria.nombrecategoria }}
                    </button>
                  </option>
                </select>
              </div>
              <div class="col-span-1 mx-7 mt-3">
                <strong>Genero: </strong>
                <p
                  class="divide divide-y mx-2 divide-black"
                  v-if="!banderamodal"
                >
                  <strong v-if="!valor"> {{ sidgeneroproducto }} </strong>
                </p>

                <select
                  v-model.number="genero"
                  v-if="valor"
                  @click="mostrar(), dos()"
                  class="shadow mt-2 rounded h-8 border-b-2 border-black w-44 flex"
                  id="grid-state"
                >
                  <option
                    v-bind:value="genero.idgenero"
                    :key="genero.idgenero"
                    v-for="genero of generos"
                  >
                    <button>
                      {{ genero.nombregenero }}
                    </button>
                  </option>
                </select>
              </div>
              <div class="col-span-1 mx-7 mt-3">
                <strong>Nivel:</strong>
                <p
                  class="divide divide-y mx-2 divide-black"
                  v-if="!banderamodal"
                >
                  <strong v-if="!valor"> {{ sidnivelproducto }} </strong>
                </p>

                <select
                  v-model.number="nivel"
                  @click="mostrar(), dos()"
                  class="shadow mt-2 rounded h-8 border-b-2 border-black w-44 flex"
                  id="grid-state"
                  v-if="valor"
                >
                  <option
                    v-bind:value="nivel.idnivel"
                    :key="nivel.idnivel"
                    v-for="nivel of niveles"
                  >
                    <button>
                      {{ nivel.nombrenivel }}
                    </button>
                  </option>
                </select>
              </div>
              <div class="col-span-1 mx-7 mt-3">
                <strong>targets:</strong>
                <p
                  class="divide divide-y mx-2 divide-black"
                  v-if="!banderamodal"
                >
                  <strong v-if="!valor"> {{ sidtargetproducto }} </strong>
                </p>
                <select
                  v-model.number="target"
                  @click="mostrar(), dos()"
                  v-if="valor"
                  class="shadow mt-2 rounded h-8 border-b-2 border-black w-44 flex"
                  id="grid-state"
                >
                  <option
                    v-bind:value="target.idtarget"
                    :key="target.idtarget"
                    v-for="target of targets"
                  >
                    <button>
                      {{ target.nombretarget }}
                    </button>
                  </option>
                </select>
              </div>
              <div class="col-span-1 mx-7 mt-3">
                <strong>Grupo:</strong>
                <p
                  class="divide divide-y mx-2 2 divide-black"
                  v-if="!banderamodal"
                >
                  <strong v-if="!valor"> {{ sidgrupoproducto }} </strong>
                </p>
                <select
                  v-if="valor"
                  v-model.number="grupo"
                  @click="mostrar(), dos()"
                  class="shadow mt-2 rounded h-8 border-b-2 border-black w-44 flex"
                  id="grid-state"
                >
                  <option
                    v-bind:value="grupo.idgrupo"
                    :key="grupo.idgrupo"
                    v-for="grupo of grupos"
                  >
                    <button>
                      {{ grupo.nombregrupo }}
                    </button>
                  </option>
                </select>
              </div>
              <div class="col-span-1 mx-7 mt-3">
                <strong>Marca:</strong>
                <p
                  class="divide divide-y mx-2 2 divide-black"
                  v-if="!banderamodal"
                >
                  <strong v-if="!valor"> {{ smarca }} </strong>
                </p>

                <select
                  v-if="valor"
                  v-model.number="marca"
                  @click="mostrar()"
                  class="shadow mt-2 rounded h-8 border-b-2 border-black w-44 flex"
                  id="grid-state"
                >
                  <option
                    v-bind:value="marcaa.idmarca"
                    :key="marcaa.idmarca"
                    v-for="marcaa of marcas"
                  >
                    <button>
                      {{ marcaa.nombremarca }}
                    </button>
                  </option>
                </select>
              </div>
              <div class="col-span-1 mx-7 mt-3">
                <strong>Caracteristica:</strong>
                <p
                  class="divide divide-y mx-2 divide-black"
                  v-if="!banderamodal"
                >
                  <strong v-if="!valor"> {{ sidcaracteristica }} </strong>
                </p>

                <select
                  v-if="valor"
                  v-model.number="caracteristica"
                  @click="mostrar(), dos()"
                  class="shadow mt-2 rounded h-8 border-b-2 border-black w-44 flex"
                  id="grid-state"
                >
                  <option
                    v-bind:value="caracteristica.idcaracteristica"
                    :key="caracteristica.idcaracteristica"
                    v-for="caracteristica of caracteristicas"
                  >
                    <button>
                      {{ caracteristica.nombrecaracteristica }}
                    </button>
                  </option>
                </select>
              </div>
            </div>
          </div>

          <div class="inline flex justify-center">
            <div>
              <button
                v-if="!banderamodal"
                @click="mostrarinicial()"
                type="button"
                class="w-full inline-flex justify-center mt-5 rounded-md border border-transparent shadow-sm px-2 py-1 bg-green-400 text-base font-medium text-white hover:bg-green-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 sm:ml-3 sm:w-auto sm:text-sm"
              >
                Modificar
              </button>
            </div>
            <div class="col-span-1">
              <button
                @click="agregartable(), clean(), recargar()"
                v-if="valor"
                type="button"
                class="w-full inline-flex justify-center mt-5 rounded-md border border-transparent shadow-sm px-2 py-1 bg-blue-600 text-base font-medium text-white hover:bg-blue-400 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:ml-3 sm:w-auto sm:text-sm"
              >
                <a href="#"> Guardar </a>
              </button>
            </div>
          </div>
        </div>
        <!--</div>-->
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";
//import axios from "axios";
export default {
  name: "modalEditarProductos",
  data() {
    return {
      respuesta: null,
      verdad: false,
      //idlinea: "",
      nombrelinea: "",
      value: null,
      descripcion: "",
      codigoproducto: "",
      costoproducto: "",
      disponibleproducto: "",
      foto: "",
      caracteristica: [],
      idproducto: "",
      idtallaproducto: "",
      idtargetproducto: "",
      idusuario: 1,
      ivaproducto: "",
      nombreproducto: "",
      referenciaproducto: "",
      reservaproducto: [],
      constoproducto: [],
      color: "",
      categoria: [],
      genero: [],
      grupo: [],
      linea: [],
      talla: [],
      nivel: [],
      target: [],
      valorventa: "",
      marca: "",
      valor: false,
    };
  },

  methods: {
    ...mapMutations("productos", [
      "agregartable",
      "cambio",
      "cargardatosproductos",
    ]),
    dos() {
      this.mostrar();
    },

    mostrar() {
      var datos = {
        codigoproducto: this.codigoproducto,
        costoproducto: this.costoproducto,
        disponibleproducto: this.disponibleproducto,
        foto: this.foto,
        idcaracteristica: this.caracteristica,
        idcategoriaproducto: this.categoria,
        idcolorproducto: this.color,
        idgeneroproducto: this.genero,
        idgrupoproducto: this.grupo,
        idlineaproducto: this.linea,
        idnivelproducto: this.nivel,
        //idproducto: this.producto,
        idtallaproducto: this.talla,
        idtargetproducto: this.target,
        idusuario: this.idusuario,
        ivaproducto: this.ivaproducto,
        nombreproducto: this.nombreproducto,
        referenciaproducto: this.referenciaproducto,
        reservaproducto: this.reservaproducto,
        constoproducto: this.costoproducto,
        valorventa: this.valorventa,
        idreferencia: this.referenciaproducto,
        idmarca:this.marca
      };

      this.cambio(datos);
    
    },
    async recargar() {
      setTimeout(() => {
        this.cargardatosproductos();
      }, 500);
    },

    mostrarinicial() {
      (this.codigoproducto = this.scodigoproducto),
        (this.costoproducto = this.scostoproducto),
        (this.disponibleproducto = this.sdisponibleproducto),
        (this.foto = this.sfoto),
        (this.caracteristica = this.sidcaracteristica),
        (this.idproducto = this.sidproducto),
        (this.idtallaproducto = this.sidtallaproducto),
        (this.idusuario = this.sidusuario),
        (this.ivaproducto = this.sivaproducto),
        (this.nombreproducto = this.snombreproducto),
        (this.referenciaproducto = this.sreferencia),
        (this.reservaproducto = this.sreservaproducto),
        (this.constoproducto = this.scostoproducto),
        (this.color = this.sidcolorproducto),
        (this.categoria = this.sidcategoriaproducto),
        (this.genero = this.sidgeneroproducto),
        (this.grupo = this.sidgrupoproducto),
        (this.linea = this.sidlineaproducto),
        (this.talla = this.sidtallaproducto),
        (this.nivel = this.sidnivelproducto),
        (this.target = this.sidtargetproducto),
        (this.valor = true);
      (this.marca = this.smarca);
      
      this.valorventa = this.svalorventa
    },

    clean() {
      (this.descripcion = null),
        (this.codigoproducto = null),
        (this.costoproducto = null),
        (this.disponibleproducto = null),
        (this.foto = null),
        (this.caracteristica = null),
        (this.idproducto = null),
        (this.idtallaproducto = null),
        (this.idtargetproducto = null),
        (this.idusuario = null),
        (this.ivaproducto = null),
        (this.nombreproducto = null),
        (this.referenciaproducto = null),
        (this.reservaproducto = null),
        (this.constoproducto = null),
        (this.color = null),
        (this.categoria = null),
        (this.genero = null),
        (this.grupo = null),
        (this.linea = null),
        (this.talla = null),
        (this.nivel = null),
        (this.target = null),
        (this.valor = false);
        (this.valorventa = null);
        (this.marca= null);
    },
  },
  computed: {
    ...mapState("productos", [
      "idmodal",
      "productos",
      "descripcionmodal",
      "scodigoproducto",
      "scostoproducto",
      "sdisponibleproducto",
      "sfoto",
      "sidcaracteristica",
      "sidcategoriaproducto",
      "sidcolorproducto",
      "sidgeneroproducto",
      "sidgrupoproducto",
      "sidlineaproducto",
      "sidnivelproducto",
      "sidproducto",
      "sidtallaproducto",
      "sidtargetproducto",
      "sidusuario",
      "sivaproducto",
      "snombreproducto",
      "sreferencia",
      "sreservaproducto",
      "sconstoproducto",
      "tipodedocumento",
      "targets",
      "tallas",
      "niveles",
      "lineas",
      "grupos",
      "generos",
      "colores",
      "categorias",
      "caracteristicas",
      "colores",
      "smarca",
      "sreferencia",
      "svalorventa",
      "marcas",
      "referencias",
    ]),
    ...mapState([
      "elemento",
      "id",
      //transportistas

      //"descripcion",
      "numero",
      // "idmodal",
      //"descripcionmodal",
      "banderamodal",
    ]),
  },
};
</script>
<style scoped >
.modal-contenido {
  background-color: rgb(255, 255, 255);
  width: auto;
  height: auto;

  margin: 15%;
  margin-top: 100px;
  position: relative;
}
.modal {
  background-color: rgba(0, 0, 0, 0.8);
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  opacity: 0;
  pointer-events: none;
  transition: all 0.1s;
}
#modalEditarProductos:target {
  opacity: 1;
  pointer-events: auto;
}
</style>

